import dayjs from "dayjs";
import type { CalendarioParams } from "../services/calendario-pagos.api";

/** Primer día del mes en curso (`YYYY-MM-DD`) · mes con el que abre el calendario. */
export function mesInicial(hoy: dayjs.ConfigType = undefined): string {
  return dayjs(hoy).startOf("month").format("YYYY-MM-DD");
}

/**
 * Params de la query PRINCIPAL del calendario (todo el mes, sin paginar) · ÚNICA
 * fuente para la página y el loader de la ruta, para que la precarga use la misma
 * queryKey (antes el loader pedía `{}` y la página el rango del mes → doble fetch
 * y skeleton en cada entrada).
 */
export function paramsCalendario(mes: string, organizacionId = "", moneda = ""): CalendarioParams {
  return {
    desde: mes,
    hasta: dayjs(mes).endOf("month").format("YYYY-MM-DD"),
    organizacionId: organizacionId || undefined,
    moneda: moneda || undefined,
  };
}
